import React from 'react';
import { ResearcherForm } from '@/features/researchers/components/ResearcherForm';
import { useResearcherForm } from '@/features/researchers/hooks/useResearcherForm';
import { useTranslation } from 'react-i18next';
import { FormWrapper } from '@/shared/components/forms';

export const ResearcherCreate = () => {
  const { t } = useTranslation();
  const form = useResearcherForm();

  return (
    <FormWrapper form={form} title={t('pages.users.create.title')}>
      <ResearcherForm form={form} />
    </FormWrapper>
  );
};
